/*
 * The responsbility of this file is to provide the styles for the Material Ui AutoComplete Input field to reuse many times in the application.
 * Pass these styles in the sx prop of the Material Ui Autocomplete component.
 */

export const autoCompleteInputStyles = {
    '.css-1n04w30-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
        {
            borderColor: '#f5f5f5'
        },
    color: '#f5f5f5 !important',
    borderRadius: '15px !important',
    minWidth: '250px',
    maxWidth: '100%',
    '& .MuiSvgIcon-root': {
        color: '#f5f5f5 !important'
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '15px',
        fontFamily: 'Nunito, sans-serif !important',
        color: '#f5f5f5',
        minWidth: '250px',
        maxWidth: '100%',
        paddingRight: '0px !important',
        '& fieldset': {
            borderColor: '#f5f5f5'
        },
        '&:hover fieldset': {
            borderColor: '#F8A21E'
        },
        '&.Mui-focused fieldset': {
            borderColor: '#F8A21E'
        },
        '& .Mui-disabled': {
            WebkitTextFillColor: '#f5f5f5',
            borderColor: '#f5f5f5 !important'
        }
    },
    '& .MuiInputLabel-root': {
        color: '#f5f5f5 !important'
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#f5f5f5',
        borderRadius: '15px',
        '&:hover fieldset': {
            borderColor: '#F8A21E !important'
        },
        '&.Mui-focused fieldset': {
            border: '1px solid #F8A21E'
        }
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#F8A21E !important'
    },
    // '& .MuiOutlinedInput-notchedOutline .Mui-disabled': {
    //     borderColor: '#f5f5f5',
    // },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#F8A21E !important'
    },
    '& .MuiChip-root': {
        backgroundColor: '#f8a21e',
        fontWeight: '600',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '1rem',
        width: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
        padding: '5px 10px'
    },
    '& .MuiChip-deleteIcon': {
        width: 'auto',
        color: '#11203A !important',
        fontSize: '1.175rem !important',
        margin: '0px !important',
        borderRadius: '50%',
        transition: 'all 0.2s'
    },
    '& .MuiChip-deleteIcon: hover': {
        color: 'white !important'
    },
    '& .MuiChip-label': {
        color: '#11203A',
        padding: '0px',
        margin: '0px'
    },
    '& .MuiFormHelperText-root': {
        color: '#f5f5f5',
        margin: '6px 0px 0px 3px',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '0.875rem',
        lineHeight: 'none',
        letterSpacing: '0px',
        '&.Mui-error': {
            color: '#f44336'
        }
    }
};

export const customListBox = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0.2rem 0rem',
    cursor: 'pointer',
    transition: 'all 0.1s ease-in-out'
};

export const listBoxItem = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0.2rem 0.5rem'
};

export const submitAndSelectAll = {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    marginTop: '0.5rem'
};

// Syntax when reuse this css in another component => Only works in AutoComplete Input field:
// 1. sx={{ ...autoCompleteInputStyles }} => we can add more styles to the sx object when reuse this css
// 2. sx={autoCompleteInputStyles} => we can't add more styles to the sx object when reuse this css
